import { createAction, props } from "@ngrx/store";
import { SPINNER } from "./spinner.constants";

export const showSpinner = createAction(SPINNER.SHOW_SPINNER);
export const hideSpinner = createAction(SPINNER.HIDE_SPINNER);
